import { RichText } from "prismic-dom";
import randomInt from "random-int";
import includes from "lodash.includes";
import objectPath from "object-path";

export const gridProgress = (page, progress, pages) =>
  (100 * page + progress) / (pages * 100) * 100;

export const pageProgress = (page, pages) => page * 100; // * page / (pages * 100) * 100;
export const pageFraction = (page, pages) => page / pages * 100; // * page / (pages * 100) * 100;

export const getSlides = (sm, lg) =>
  typeof window === "undefined" ? 6 : window.innerWidth < 768 ? sm : lg;

export const linkResolver = doc => {
  if (doc.type === "article") return "/article/" + doc.uid;
  // Fallback for other types, in case new custom types get created
  return "/article/" + doc.id;
};

export const toHtml = src => (src.html ? src.html : ""); //RichText.asHtml(src, linkResolver);

export const noDummy = edges => edges;

export const progress = (step = 5, spread) => {
  let lastProgress = 0;
  let lastIndex = randomInt(0, spread - 1);
  return progress => {
    if (progress > lastProgress + step || progress < lastProgress - step) {
      lastProgress = progress;
      lastIndex = randomInt(0, spread - 1);
    }
    return lastIndex;
  };
};

export const getText = (src, path, fallback = "") => {
  const str = objectPath.get(src, path, fallback);
  console.log(RichText.asHtml(str, linkResolver));
  if (!str) {
    return "";
  }
  return typeof str === "string" ? str : RichText.asHtml(str, linkResolver);
};

export const fieldExists = (src, path) => getText(src, path).length > 0;



// WEBPACK FOOTER //
// ./src/utilities/index.js